import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { ModuleManagerExportFormat } from 'src/shared/models/module-manager/module-manager-options.model';
import { ApiResponse } from 'src/AngularJS/Models/api-response.model';
import { MetricReviewData } from './metric-review.models';

@Injectable({
    providedIn: 'root'
})
export class MetricReviewService {

    constructor(
        private cvApi: CVApiService,
    ) { }

    public async fetchModuleData(moduleKey: string, isAutoRefresh?: boolean, isFirstLoad?: boolean, abort?: Promise<void>): Promise<ApiResponse<MetricReviewData>> {
        const moduleRenderUrl = await this.cvApi.getModuleRenderEndPoint(moduleKey);
        return await this.cvApi.get<MetricReviewData>(`/api/v2/dashboards/modules/metricreview/${moduleKey}?isAutoRefresh=${!!isAutoRefresh}&isFirstLoad=${!!isFirstLoad}`, moduleRenderUrl, abort);
    }

    public async fetchExportData(moduleKey: string, format: ModuleManagerExportFormat = ModuleManagerExportFormat.Excel): Promise<ApiResponse<string>> {
        const moduleRenderUrl = await this.cvApi.getModuleRenderEndPoint(moduleKey);
        return await this.cvApi.get<string>(`/api/v2/dashboards/modules/metricreview/${moduleKey}/export?format=${format}`, moduleRenderUrl);
    }

}
